import { getSupabase } from "@/lib/supabase/client";

export async function getAccessToken(): Promise<string | null> {
  const supabase = getSupabase();
  if (!supabase) return null;
  const { data } = await supabase.auth.getSession();
  return data.session?.access_token ?? null;
}

export const API_BASE =
  import.meta.env.VITE_API_URL ?? "http://localhost:8787";
